var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/BackButton/BackButton.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import Button, { VARIANTS } from "react-gazelle/lib/components/Button";
import Alert from "../Alert/Alert";
import { submitPage } from "../../network/surveyClient";
var BackButton = function BackButton(_ref) {
  var surveyPage = _ref.surveyPage,
    analyticsTrackingName = _ref.analyticsTrackingName,
    onSubmissionSuccess = _ref.onSubmissionSuccess,
    _ref$unauthenticated = _ref.unauthenticated,
    unauthenticated = _ref$unauthenticated === void 0 ? false : _ref$unauthenticated;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    alertMessage = _useState2[0],
    setAlertMessage = _useState2[1];
  var PREVIOUS = "Previous";
  var ERROR_MESSAGE = "We're sorry! We ran into a problem. Please try again.";
  var DEFAULT_KEY = "SURVEY-PREVIOUS";
  var initialValues = [];
  useEffect(function () {
    setAlertMessage("");
  }, [surveyPage]);

  /**
   * Allows the user to go to the previous page.
   * Does not send the user's responses to the API.
   * @param  {any} _ Required by Formik, but not used.
   * @param  {FormikBag} setSubmitting Formik function
   * @returns {void}
   */
  var handleSurveyPreviousSubmission = function handleSurveyPreviousSubmission(_, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    var submissionEndpoint = surveyPage._embedded.previous.href;
    setAlertMessage("");
    submitPage(submissionEndpoint, {
      // eslint-disable-next-line camelcase
      user_response: []
    }, unauthenticated).then(function (response) {
      setSubmitting(false);
      onSubmissionSuccess(response);
    })["catch"](function () {
      setAlertMessage(ERROR_MESSAGE);
      setSubmitting(false);
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Alert, {
    message: alertMessage,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Formik, {
    key: DEFAULT_KEY,
    onSubmit: handleSurveyPreviousSubmission,
    initialValues: initialValues,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }, function (formik) {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: formik.handleSubmit,
      "data-analytics-form": analyticsTrackingName,
      noValidate: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-spacingStack2",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Button, {
      "data-testid": "PreviousButton",
      type: "submit",
      variant: VARIANTS.BORDERLESS,
      disabled: formik.isSubmitting,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "u-typesetBodySmall",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 17
      }
    }, PREVIOUS))));
  }));
};
BackButton.propTypes = {
  surveyPage: PropTypes.shape({
    _embedded: PropTypes.shape({
      previous: PropTypes.shape({
        href: PropTypes.string
      })
    })
  }).isRequired,
  analyticsTrackingName: PropTypes.string.isRequired,
  onSubmissionSuccess: PropTypes.func.isRequired
};
export { BackButton as default };